export enum ConnectionPointType {
    PI,
    SQL,
    WideDatabase,
    Excel,
    csv,
    Manual,
    OPCHDA,
    SMTP,
    CSVDataTable,
    Wonderware,
    DataGeneration,
    ManualFile,
    PIAF,
    PepiteDataLake,
    DataFolder,
    HTTP,
    Oracle,
    GridVis,
    FaSTRepo,
    CSVExport,
    MariaDB,
    ArchestrA,
    DataMailBox,
    Npgsql,
    WideDatabaseNpgsql,
    FaSTInfluxDB2,
    Bazefield,
    Argus,
    Ewattch,
    HydrometrieKiwis
}